import { LinearSolveStop, type ValuationLinearSolveRes } from '@dealstack/shared/lib/generated';

const NOT_EXACT_STOPS: ReadonlySet<LinearSolveStop> = new Set([
	LinearSolveStop.STARVED,
	LinearSolveStop.OVERRAN,
	LinearSolveStop.RESTART_LIMIT,
]);

export const showLinearSolveWarning = (status?: ValuationLinearSolveRes): boolean =>
	status !== undefined && NOT_EXACT_STOPS.has(status.stop);
